<template>
  <div class="press">
    <div class="campus">出版社管理</div>
    <div class="xiaoqu">
      <el-card :span="24">
        <div class="grid-content">
          <div class="header">全部出版社</div>
          <el-button type="primary" class="mb-24" @click="addPress('forms')">
            新建出版社
          </el-button>
          <div class="search">
            <span>出版社名称：</span>
            <el-input v-model="searchName" @keyup.13.native="getPressList" placeholder="请输入出版社名称"></el-input>
            <el-button type="primary" class="buttons" @click="getPressList">查 询</el-button>
          </div>

          <div class="tableStyle">
            <el-table :data="tableData" style="width: 100%">
              <el-table-column label="出版社形象" min-width="70">
                <template slot-scope="scope">
                  <img class="tableImg" :src="scope.row.picurl" />
                </template>
              </el-table-column>
              <el-table-column prop="name" label="出版社名称" min-width="50">
              </el-table-column>
              <el-table-column prop="shortname" label="出版社简称" min-width="50">
              </el-table-column>
              <el-table-column prop="englishname" label="英文名称" min-width="50">
              </el-table-column>
              <el-table-column prop="seqnum" label="排序" min-width="50">
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button type="text" @click="editPress(scope.row)">编辑</el-button>
                  <el-button type="text" @click="$router.push({path:'/textbookSeries',query:{id:scope.row.id}})">教材系列</el-button>
                  <!-- <el-button type="text" @click="deletPress(scope.row)">删除</el-button> -->
                  <!-- <el-button type="text" @click="lookPress(scope.row)">查看</el-button> -->
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="dz-flex dz-flex-justify-end mt-12">
            <el-pagination background @size-change="getPressList" @current-change="getPressList" :current-page.sync="page"
              :page-sizes="[5, 10, 30, 50, 100]" :page-size.sync="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
          </div>
        </div>
      </el-card>
    </div>
    <!-- 会话框 -->
    <div class="dialogStyle">
      <!-- 新建,编辑出版社 -->
      <el-dialog :title="dialogType ? '编辑出版社':'新增出版社'" :visible.sync="publicDialog" width="600px" center>
        <el-form ref="forms" :model="forms" :rules="FormRules" label-width="120px">
          <el-form-item label="出版社名称:" prop="name">
            <el-input v-model="forms.name" placeholder="请输入出版社名称"></el-input>
          </el-form-item>
          <el-form-item label="出版社简称:" prop="shortname">
            <el-input v-model="forms.shortname" placeholder="请输入出版社简称"></el-input>
          </el-form-item>
          <el-form-item label="英文名称:" prop="englishname">
            <el-input v-model="forms.englishname" placeholder="请输入英文名称" onkeyup="this.value=this.value.replace(/[\u4E00-\u9FA5]/g,'')">
            </el-input>
          </el-form-item>
          <el-form-item label=" 排序:" prop="seqnum">
            <el-input-number v-model="forms.seqnum" :min="1" :max="99999999" label="描述文字"></el-input-number>
          </el-form-item>
          <el-form-item label="出版社封面:" prop="picurl">
            <!-- <i>
              <img src="@/assets/img/education-manage/campus/bitian.png" style="left: -5vw; top: 0.78125vw" />
            </i> -->
            <el-upload class="avatar-uploader" action="#" :auto-upload="false" v-model="forms.picurl" :show-file-list="false"
              :on-change="collectlist">
              <el-button v-if="dialogType===1" type="primary" size="samll">更换图片</el-button>
              <el-button v-else type="primary" size="samll">上传图片</el-button>
              <div v-show="forms.picurl">
                <img :src="forms.picurl" class="avatar mt-10" />
              </div>
            </el-upload>
            <div class="jianyi">
              <span>( 建议：JPG或PNG图片， 推荐：400*400)</span>
            </div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="publicDialog = false">取 消</el-button>
          <el-button type="primary" @click="submitAdd">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
const FormRules = {
  name: [
    {
      required: true,
      message: '请输入出版社名称',
      trigger: ['blur', 'change'],
    },
  ],
  shortname: [
    {
      required: true,
      message: '请输入出版社简称',
      trigger: ['blur', 'change'],
    },
  ],
  englishname: [
    {
      required: true,
      message: '请输入英语名称',
      trigger: ['blur', 'change'],
    },
  ],
  seqnum: [
    {
      required: true,
      message: '请选择排序',
      trigger: ['blur', 'change'],
    },
  ],
  picurl: [
    {
      required: true,
      message: '请上传封面',
      trigger: ['blur', 'change'],
    },
  ],
};
import { $upload } from '@/api/upload';
import { $addPress, $editPress } from '@/api/press';
import { $debounce } from '@/utils/index';
export default {
  name: 'press',
  data() {
    return {
      FormRules,
      searchName: '',
      tableData: [],
      // 检索表单数据对象
      page: 1,
      pageSize: 10,
      total: 0,

      publicDialog: false,
      dialogType: '',
      forms: {
        name: '',
        shortname: '',
        englishname: '',
        seqnum: 1,
        picurl: '',
      },
    };
  },
  created() {
    this.$nextTick(() => {
      // 调用 查询出版社列表
      this.getPressList();
    });
  },
  methods: {
    // 查询出版社列表
    async getPressList() {
      let data = {
        name: this.searchName,
        page: this.page,
        pageSize: this.pageSize,
      };
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/publisher/selectPublisherPage',
        method: 'POST',
        data: data,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.tableData = result.data.data;
          this.total = result.data.size;
        })
        .catch((err) => {
          return this.$message.error('查询失败！：' + err);
        });
    },
    // 新增出版社
    addPress(formName) {
      this.publicDialog = true;
      this.$nextTick(() => {
        this.$refs[formName].resetFields();
        this.dialogType = 0;
      });
    },
    // 编辑出版社
    editPress(row) {
      this.forms = JSON.parse(JSON.stringify(row));
      this.dialogType = 1;
      this.publicDialog = true;
    },
    // 确认新增和编辑出版社  新增dialogType:0 编辑dialogType:1
    submitAdd: $debounce(function () {
      this.$refs['forms'].validate(async (valid) => {
        let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
        //   // 如果表单验证失败，停止请求提交
        if (!valid) {
          this.$message.error('新增信息缺失！');
          return;
        } else {
          if (this.dialogType) {
            // const res = await $editPress(this.forms);
            // if (res.data.code === 0) {
            //   this.getPressList();
            // }
            // this.publicDialog = false;
            // this.$message.success(res.data.message);

            let pro = this.$http({
              url: '/edu/publisher/updatePublisher',
              method: 'POST',
              data: this.forms,
              headers: {
                Authorization: 'Bearer ' + token,
              },
            });
            pro
              .then((result) => {
                if (result.data.code !== 0) {
                  this.publicDialog = false;
                  return this.$message.error(result.data.message);
                }
                this.getPressList();
                this.$message.success(result.data.message);
                this.publicDialog = false;
                this.forms = {};
              })
              .catch((err) => {
                return this.$message.error('编辑失败！：' + err);
              });
          } else {
            // const res = await $addPress(this.forms);
            // if (res.data.code === 0) {
            //   this.getPressList();
            // }
            // this.$message.success(res.data.message);
            // this.publicDialog = false;
            let pro = this.$http({
              url: '/edu/publisher/addPublisher',
              method: 'POST',
              data: this.forms,
              headers: {
                Authorization: 'Bearer ' + token,
              },
            });
            pro
              .then((result) => {
                if (result.data.code !== 0) {
                  this.publicDialog = false;
                  return this.$message.error(result.data.message);
                }
                this.getPressList();
                this.$message.success(result.data.message);
                this.publicDialog = false;
              })
              .catch((err) => {
                return this.$message.error('新建失败！：' + err);
              });
          }
        }
      });
    }, 500),
    collectlist(data) {
      // console.log(data, 'asdad');
      let orgid = window.sessionStorage.getItem('orgid');
      let formData = new FormData();
      formData.append('file', data.raw);
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/uploadOss/uploadImage',
        method: 'POST',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((res) => {
          // console.log(result);
          if (res.data.code === 0) {
            this.$set(this.forms, 'picurl', res.data.data);
            console.log(this.forms.picurl);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error('上传图片错误：' + err);
        });
    },
    // 查看出版社
    lookPress() {},
    // 删除出版社
    deletPress() {},
  },
};
</script>

<style lang="less" scoped>
.press {
  .jianyi {
    font-size: 12px !important;
    color: #cccccc;
    position: absolute;
    top: 0;
    left: 135px;
  }
  .el-button--text:active {
    color: #00a6e6;
  }
  .el-button--text {
    color: #00a6e6;
  }
  .avatar-uploader {
    img {
      width: 120px;
      height: 120px;
    }
  }
  /deep/.el-upload {
    text-align: left;
  }
  .tableImg {
    width: 80px;
    height: 80px;
  }
  /deep/.el-card__body {
    padding: 0 1.3vw;
  }
}
</style>
